module.exports = __webpack_public_path__ + "img/ae-3.1532b05.png";